import BlNavBarStepperMv from './BlNavBarStepperMv.vue'

BlNavBarStepperMv.install = function(Vue) {
  Vue.component(BlNavBarStepperMv.name, BlNavBarStepperMv)
}

export default BlNavBarStepperMv
